export default {"src":"/_next/static/media/free-return.d291b78b.svg","height":15,"width":14};